import _ from 'lodash';
import { apiSearch } from './utility';

export const searchNotifierLogs = (p = {}) => {
	const callback = p.callback || _.noop;
	return dispatch => {
		apiSearch({
			method : 'notifier.logs.search',
			base : 'notifierLog',
			dispatch : dispatch,
			callback : callback,
		});
	};
};
